import { useState, useEffect, useRef } from 'react';
import { Tooltip } from '@mui/material';
import StyledWrapper from '../../../pages/IndividualProgram/style';

const SimpleTooltip = ({ cellValues }) => {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const cardRowRef = useRef(null);

	useEffect(() => {
		if (cardRowRef.current) {
			setIsOverflowing(cardRowRef.current.scrollWidth > cardRowRef.current.clientWidth);
		}
	}, [cellValues]);

	return (
		<Tooltip arrow placement="top" title={isOverflowing ? `${cellValues?.formattedValue}` : ''}>
			<StyledWrapper.CardRowInfo
				ref={cardRowRef}
				data-testid={`${cellValues?.field}-${cellValues?.id}`}
			>
				{cellValues?.formattedValue}
			</StyledWrapper.CardRowInfo>
		</Tooltip>
	);
};

export default SimpleTooltip;
